module.exports = __webpack_public_path__ + "img/t5-black.ecd16899.png";